//export const SERVER_URL = `http://ec2-13-232-157-200.ap-south-1.compute.amazonaws.com:5000/`;
//export const SERVER_URL = `https://localhost:3443/`;
//export const DAYCARE_ID = `66e0bf82cea95049fc71d2d2`;
export const SESSION_NAME = `June 2026`;

export const SERVER_URL = `https://server.stepswatch.co.in/`;
export const DAYCARE_ID = `Vanille-Frais/SWIN-002`;

